// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2OQUV","options":"AnswerScale_options__HqA7q","selected":"AnswerScale_selected__387uX"};